import request from '@/utils/request'

//保存、提交
export const addAbnormalTermination = (data) => {
   return request.post('/api/agent/abnormalTermination/add', data)
}

//标段列表
export const getBidSectionList = (projectCode) => {
   return request.get('/api/agent/abnormalTermination/bidSectionList?projectCode='+projectCode)
}

//删除
export const deleteAbnormalTermination = (params) => {
   return request.post('/api/agent/abnormalTermination/delete?guid='+params.guid )
}

//详情
export const getAbnormalTerminationDetail = (params) => {
   return request.get('/api/agent/abnormalTermination/detail?guid='+params.guid )
}

//是否已发布异常终止 (限制投标人进入流程)
export const checkIsPublish = (params) => {
   return request.get('/api/agent/abnormalTermination/isPublish?bidSectionCode='+params.bidSectionCode)
}

//列表
export const getAbnormalTerminationList = (params) => {
   return request.get('/api/agent/abnormalTermination/list',  params )
}

